import { Link } from "@tanstack/react-router";
import type { WaveQA } from "@/data/_qa/legal-clusters";

/**
 * Internal-link block that surfaces a cluster's Q&A hub (and its top questions)
 * from the pillar page, so question pages are reachable by crawlers without
 * relying on the sitemap alone.
 */
export function QaHubCta({
  base,
  label,
  qa,
  limit = 12,
}: {
  /** cluster route base, e.g. "/estate" */
  base: string;
  label: string;
  qa: WaveQA[];
  limit?: number;
}) {
  const top = qa.slice(0, limit);
  const to = (href: string) => href as never;
  return (
    <section className="mx-auto max-w-6xl px-4 py-8">
      <h2 className="mb-3 text-2xl font-bold">คำถามที่พบบ่อยเรื่อง{label}</h2>
      <p className="answer-summary mb-4 text-sm leading-relaxed" data-speakable>
        รวม {qa.length.toLocaleString("th-TH")} คำถามพร้อมคำตอบละเอียดที่จบในตัวเอง ครอบคลุมขั้นตอน เอกสารที่ต้องเตรียม
        ระยะเวลา หน่วยงานที่เกี่ยวข้อง และข้อควรระวัง · เว็บไซต์ไม่แสดงค่าบริการ สอบถามใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE
        หรืออีเมล
      </p>
      <ul className="grid gap-2 text-sm md:grid-cols-2 lg:grid-cols-3">
        {top.map((item) => (
          <li key={item.slug}>
            <Link to={to(`${base}/q/${item.slug}`)} className="text-blue-700 hover:underline">
              {item.q}
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm">
        <Link to={to(`${base}/questions`)} className="font-semibold text-blue-700 hover:underline">
          ดูคำถามทั้งหมด {qa.length.toLocaleString("th-TH")} ข้อ →
        </Link>
      </p>
    </section>
  );
}
